import React, { useState, useEffect } from "react";
import { Modal, Button, Form, FloatingLabel } from "react-bootstrap";

const PlantFormModal = ({ show, onHide, onSave, initialData = null }) => {
    const [form, setForm] = useState({ name: "", location: "" });

    useEffect(() => {
        if (initialData) {
            setForm(initialData);
        } else {
            setForm({ name: "", location: "" });
        }
    }, [initialData]);


    const handleSubmit = () => {
        onSave(form);
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>{initialData ? "Edit" : "Add"} Plant</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <FloatingLabel label="Plant Name" className="mb-3">
                        <Form.Control
                            value={form.name}
                            onChange={e => setForm({ ...form, name: e.target.value })}
                            required
                        />
                    </FloatingLabel>
                    <FloatingLabel label="Location" className="mb-3">
                        <Form.Control
                            value={form.location}
                            onChange={e => setForm({ ...form, location: e.target.value })}
                            required
                        />
                    </FloatingLabel>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>Cancel</Button>
                <Button variant="primary" onClick={handleSubmit}>
                    {initialData ? "Update" : "Save"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PlantFormModal;
